module.exports = __webpack_public_path__ + "media/images/icons/arrow_up-4d6e361924a6c6e71e52170ba755c0ec.svg";